import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from 'styletron-react';
import { staticColors } from '../../const/colors/staticColors';
const StyledExternalLink = styled('a', {
    color: staticColors.textAction,
    textDecoration: 'underline',
    ':hover': {
        cursor: 'pointer',
        textDecoration: 'none',
    },
});
export const ExternalLink = (props) => (_jsx(StyledExternalLink, { ...props }));
